export default __webpack_public_path__ + "static/media/solitaire-icon.949145f2.webp";